import CKEditor from "ckeditor4-react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Media from "react-media";
import styled from "styled-components";

import AlwaysShowBlocks from "./alwaysShowBlocks/AlwaysShowBlocks";

import PolicyRenderer from "pstat-anywhere/components/document_control/policy_styling/PolicyRenderer";
import { TERTIARY_NAVBAR_HEIGHT } from "pstat-anywhere/components/partials/tertiary_nav";
import theme from "pstat-anywhere/themes/policystat/theme";
import { SIDEBAR_MOBILE_HEIGHT } from "pstat-design-system/SideBarMenu";
import Sticky from "pstat-design-system/Sticky";


const CKWrapper = styled.div`
  position: relative;
`;

const Editor = props => {
  const [loading, setLoading] = useState(true);
  const editorWrapper = useRef(null);
  const waitingToUpdateChanges = useRef(false);
  const config = {
    customConfig: `${window.MEDIA_URL}lib/ckeditor-common/editor_config.js`
  };
  const { newCkeditor, rtlSupport } = props;
  const { t } = useTranslation();
  const ckeditorPath = newCkeditor ? "ckeditor-new" : "ckeditor";
  CKEditor.editorUrl = `${window.MEDIA_URL}lib/${ckeditorPath}/ckeditor.js`;

  // ckeditor customConfig expects this to be set
  window.PolicyStat = window.PolicyStat || {};
  window.PolicyStat.rtlSupport = rtlSupport;
  const setUp = event => {
    const editor = event.editor;
    editor.lang.clipboard.securityMsg = t("editor.securityMessage");
    editor.lang.clipboard.pasteMsg = t("editor.pasteMessage");

    editor.on("beforeCommandExec", event => {
      if (event.data.name === "paste") {
        event.editor._.forcePasteDialog = true;
      }

      // Don't show the paste dialog for Ctrl+Shift+V
      if (
        event.data.name === "pastetext" &&
        event.data.commandData.from === "keystrokeHandler"
      ) {
        event.cancel();
      }
    });
    props.setEditor(editor);
  };

  const grammarlyWorkaround = event => {
    event.editor.editable().data("gramm", "false");
  };

  const handleChange = event => {
    if (waitingToUpdateChanges.current) {
      return;
    }
    waitingToUpdateChanges.current = true;
    setTimeout(() => {
      props.onChange(event.editor.getData());
      waitingToUpdateChanges.current = false;
    }, 1000);
  };

  const toolbarWidth = editorWrapper.current
    ? editorWrapper.current.getBoundingClientRect().width
    : null;
  return (
    <Media query={{ minWidth: theme.breakpoints[1] }}>
      {isDesktop => (
        <CKWrapper className="ck-wrapper" innerRef={editorWrapper}>
          <Sticky
            id="editor-controls"
            offset={
              isDesktop
                ? TERTIARY_NAVBAR_HEIGHT
                : TERTIARY_NAVBAR_HEIGHT + SIDEBAR_MOBILE_HEIGHT
            }
            zIndex={theme.layers.tertiaryNav - 1}
            loading={loading}
            width={toolbarWidth}
          >
            <div id="editor-toolbar"></div>
          </Sticky>
          <PolicyRenderer otherStyles={props.editorStyles}>
            <div className="document">
              <div id="editor-content" className="document_body">
                <AlwaysShowBlocks>
                  <CKEditor
                    data={props.content}
                    config={config}
                    type="inline"
                    onInstanceReady={event => {
                      setUp(event);
                      grammarlyWorkaround(event);
                      setLoading(false);
                    }}
                    onChange={handleChange}
                  />
                </AlwaysShowBlocks>
              </div>
            </div>
          </PolicyRenderer>
        </CKWrapper>
      )}
    </Media>
  );
};

export default Editor;
